import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { LazySearchSelectComponent } from './lazy-search-select.component';

@NgModule({
  declarations: [LazySearchSelectComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  exports: [LazySearchSelectComponent]
})
export class LazySearchSelectModule { }
